import angular from 'angular';

import LicensesFactory from './licensesFactory';
import LicensesUtilityFactory from './licensesUtilityFactory';

import LicensesTableController from './licensesTable/licensesTableController';
import AddLicenseController from './addLicense/addLicenseController';
import AddCALicenseController from './addLicense/CA/addCALicenseController';
import AddFLLicenseController from './addLicense/FL/addFLLicenseController';
import DeleteLicenseController from './deleteLicense/deleteLicenseController';

import './licenses.scss'; // no controller to import this from

export default angular.module('app.accounts.licenses', [])
    .controller('LicensesTableController', LicensesTableController)
    .controller('AddLicenseController', AddLicenseController)
    .controller('AddFLLicenseController', AddFLLicenseController)
    .controller('AddCALicenseController', AddCALicenseController)
    .controller('DeleteLicenseController', DeleteLicenseController)
    .factory('LicensesFactory', LicensesFactory)
    .factory('LicensesUtilityFactory', LicensesUtilityFactory)
    .run(($templateCache) => {
        $templateCache.put('app/accounts/licenses/licensesTable/licensesTable.html', require('./licensesTable/licensesTable.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/licenses/addLicense/addLicense.html', require('./addLicense/addLicense.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/licenses/addLicense/businessLicense/addBusinessLicense.html', require('./addLicense/businessLicense/addBusinessLicense.html'));// eslint-disable-line global-require
        $templateCache.put('app/accounts/licenses/addLicense/FL/licenseFL.html', require('./addLicense/FL/licenseFL.html'));
        $templateCache.put('app/accounts/licenses/deleteLicense/deleteLicense.html', require('./deleteLicense/deleteLicense.html'));
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/accounts/licenses/index.js